// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__YBBTN","main":"Layout_main__vw-XG","reduceWidth":"Layout_reduceWidth__s2KYe"};